export const ToastEventType = 'alva-toast' as const;
